import { render, staticRenderFns } from "./inflections-browser.vue?vue&type=template&id=52a62614&"
import script from "./inflections-browser.vue?vue&type=script&lang=js&"
export * from "./inflections-browser.vue?vue&type=script&lang=js&"
import style0 from "./inflections-browser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a62614')) {
      api.createRecord('52a62614', component.options)
    } else {
      api.reload('52a62614', component.options)
    }
    module.hot.accept("./inflections-browser.vue?vue&type=template&id=52a62614&", function () {
      api.rerender('52a62614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/inflections-browser.vue"
export default component.exports